import React, { useEffect } from 'react'
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonRow, IonCol, IonLabel, IonInput, IonItem, IonTextarea, IonItemDivider, IonIcon, IonButton, IonList, useIonViewWillEnter, IonButtons, IonBackButton } from '@ionic/react'
import db from '../../resources/db'
import moment from 'moment'
import { trash } from 'ionicons/icons'
import AddItem from './AddItem'
import { toastController } from '@ionic/core'
import { usePurchaseEntry } from '../../contexts/usePurchaseEntry'
import { useLocalStorage } from '../../resources/Hooks'

const PurchaseEntry = () => {

    useIonViewWillEnter(async () => {
        // this will attach the already present customer while auto-completing the customer name
        let nameplace = await document.getElementById('partyName').getInputElement()
        nameplace.setAttribute('list', 'customerList')
    })

    const { aggregateTotals,
        Config,
        CustomerList, Company,
        Products,
        partyName, setpartyName,
        partyDetails, setpartyDetails,
        partyContact, setpartyContact,
        date, setDate,
        AmtPaid, setAmtPaid,
        partyGST, setPartyGST,
        addProduct, removeProduct, clearAll } = usePurchaseEntry();


    const [billNo, setBillNo] = useLocalStorage('billno', 1)
    const [gstBillNo, setgstBillNo] = useLocalStorage('gstbillno', 1);

    const gstPattern = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;

    const { subTotal, gstTotal, total } = aggregateTotals();



    /** Creates Purchase Entry*/
    const AddtoPurachase = () => {
        let billDate = moment(date).format('ll');

        /** Purchase Json */
        const entry = {
            id: Date.now(),
            gstEnabled: Config.gst.enabled,
            billNo: Config.gst.enabled ? "PG-" + gstBillNo : "P-" + billNo,
            billDate,
            partyName: partyName.length ? partyName.trim() : "******",
            partyGST: partyGST ? partyGST.trim().toUpperCase() : "",
            partyDetails: partyDetails ? partyDetails.trim() : "",
            partyContact: partyContact ? partyContact.trim() : "",
            companyName: Company.name,
            companyAddress: Company.address,
            companyContact: Company.contact,
            gst: Company.gst,
            products: Products,
            salestype: "purchase",
            subtotalAmt: subTotal,
            gstTotal: gstTotal,
            totalAmt: total,
        }

        const ledger = {
            billId: entry.id,
            billNo: entry.billNo,
            customerName: partyName.length ? partyName.trim() : "******",
            customerGST: partyGST ? partyGST.trim().toUpperCase() : "",
            customerDetails: partyDetails ? partyDetails.trim() : "",
            customerContact: partyContact ? partyContact.trim() : "",
            date: billDate,
            credit: parseFloat(total),
            debit: parseFloat(AmtPaid ? AmtPaid : 0),
            payable: parseFloat(total) - parseFloat(AmtPaid ? AmtPaid : 0),
            receivable: 0,
            isCustomer: 0, //false
        }
        ledger.cash = -ledger.debit


        if ((!gstPattern.test(ledger.customerGST)) && (ledger.customerGST !== "")) {
            toastController.create({
                color: 'danger',
                duration: 2000,
                message: "GST No. is Wrong. Fill the Correct one to Generate Bill.",
                showCloseButton: true
            }).then(toast => {
                toast.present();
            });

            return;
        }

        // add to db
        if (entry.products.length) {

            db.db.transaction('rw', db.purchase, db.ledger, db.stocks, () => {
                db.purchase.put(entry).then((res) => {
                    console.log('Entry Done ', res);
                })
                db.ledger.put(ledger).then((res) => {
                    console.log('Ledger Generated', res);
                })
                Products.forEach((product) => {
                    let logentry = {
                        id: `stk_${Date.now()}`,
                        to: ledger.customerName,
                        billNo: entry.billNo,
                        date: billDate,
                        type: "Purchase",
                        quantity: product.quantity,
                        rate: product.rate,
                        amount: product.amount,
                    }

                    db.stocks.where("productName").equals(product.name).modify((value, ref) => {
                        console.log(value, ref)
                        // let q = value.quantity
                        // console.log(q);
                        // ref.value.quantity = q + parseFloat(product.quantity)
                        value.log.push(logentry)
                    }).then((res) => {
                        console.log('updated stocks', res);
                        if (!res && product.name) {

                            let stockdata = {
                                productName: product.name,
                                quantity: parseFloat(product.quantity),
                                purchaseRate: parseFloat(product.rate),
                                rate: 0,
                                gstRate: parseFloat(product.gstr ? product.gstr : 0),
                                hsn: '',
                                log: [],
                            }

                            db.stocks.put(stockdata).then((res) => {
                                console.log('Product Item added.', res);
                                db.stocks.where("productName").equals(product.name).modify((value, ref) => {
                                    console.log(value, ref)
                                    // console.log(q);
                                    value.log.push(logentry)
                                })
                            });
                        }
                    });
                })
            }).then(() => {
                if (Config.gst.enabled) {
                    setgstBillNo(parseInt(gstBillNo) + 1);
                } else {
                    setBillNo(parseInt(billNo) + 1);
                }
                toastController.create({
                    color: 'success',
                    duration: 2000,
                    message: "Added Purchase Entry Succesfully",
                    showCloseButton: true,
                    position: 'top'
                }).then(toast => {
                    toast.present();
                });
                clearAll();
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }).catch((err) => { console.log(err) });

        } else {

            toastController.create({
                color: 'danger',
                duration: 2000,
                message: "ERROR Adding Purchase Entry",
                showCloseButton: true,
                position: 'middle'
            }).then(toast => {
                toast.present();
            });
        }
    }

    const ProductTable = (
        <IonList className='product-table' >
            <IonItem color='medium'>
                <IonCol style={{ textAlign: "center" }}>S.No.</IonCol>
                <IonCol className='ion-padding-horizontal' style={{ textAlign: "center" }}>Product Name </IonCol>
                <IonCol style={{ textAlign: "center" }}>Quantity</IonCol>
                <IonCol style={{ textAlign: "center" }}>Unit Rate</IonCol>
                <IonCol style={{ textAlign: "center" }}>Amount </IonCol>
                {Config.gst.enabled && (<>
                    <IonCol style={{ textAlign: "center" }}>GST Rate </IonCol>
                    <IonCol style={{ textAlign: "center" }}>GST Amt </IonCol>
                    <IonCol style={{ textAlign: "center" }}>Total </IonCol>
                </>
                )}
                <IonCol style={{ textAlign: "center" }}>Remove </IonCol>
            </IonItem>
            {Products && Products.map(((item, i) => {
                return (
                    <IonItem key={item.id}>
                        <IonCol style={{ textAlign: "center" }}>{i + 1}</IonCol>

                        <IonCol style={{ textAlign: "center" }}>{item.name}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{item.quantity}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{parseFloat(item.rate).toFixed(2)}</IonCol>
                        <IonCol style={{ textAlign: "center" }}>{parseFloat(item.amount).toFixed(2)}</IonCol>

                        {Config.gst.enabled && (<>
                            <IonCol style={{ textAlign: "center" }}>{item.gstr}</IonCol>
                            <IonCol style={{ textAlign: "center" }}>{parseFloat(item.gstAmt).toFixed(2)}</IonCol>
                            <IonCol style={{ textAlign: "center" }}>{parseFloat(item.total).toFixed(2)}</IonCol>
                        </>)}

                        <IonCol style={{ textAlign: "center" }}><IonIcon icon={trash} style={{ cursor: 'pointer' }} onClick={() => removeProduct(item.id, item.name, item.quantity)}></IonIcon></IonCol>
                    </IonItem>
                )


            }))}
        </IonList>
    )

    const customers = CustomerList.length ? (
        CustomerList.map((p) => {
            // console.log(p);
            return (
                <option key={p} value={p}></option>
            )
        })
    ) : (null)


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                    </IonButtons>
                    <IonTitle>Purchase Entry</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding'>
                <IonRow>
                    <IonCol sizeMd='3'>
                        <IonItem>
                            <IonLabel position='floating'>Party Name</IonLabel>
                            <IonInput type='text' id="partyName" debounce={1000} autoCapitalize='word' autocomplete='on' placeholder='Name' name='' value={partyName} onIonInput={(e) => {
                                setpartyName((e.target.value).trim());
                                db.ledger.get({ customerName: (e.target.value).trim() }).then((party) => {
                                    if (party) {
                                        setpartyContact(party.customerContact)
                                        setpartyDetails(party.customerDetails)
                                        setPartyGST(party.customerGST)
                                    }

                                })
                            }}></IonInput>
                            <datalist id='customerList'>
                                {customers}
                            </datalist>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Party Contact</IonLabel>
                            <IonInput type='tel' id="partyContact" placeholder='+91' value={partyContact} onIonInput={(e) => { setpartyContact((e.target.value).trim()) }}></IonInput>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Party Details</IonLabel>
                            <IonTextarea id="partyDetails" value={partyDetails} onIonInput={(e) => { setpartyDetails((e.target.value).trim()) }} ></IonTextarea>
                        </IonItem>

                        {
                            Config.gst.enabled ? (
                                <IonItem>
                                    <IonLabel position='floating'>Party GST</IonLabel>
                                    <IonInput type='text' id="partyGST" value={partyGST} onIonInput={(e) => { setPartyGST((e.target.value).trim()) }}></IonInput>
                                </IonItem>
                            ) : ('')
                        }

                    </IonCol>

                    <IonCol sizeMd='3' offsetMd='5'>

                        <IonItem>
                            <IonLabel position='stacked'>Date</IonLabel>
                            <input type='date' id="date" value={moment(date).format('YYYY-MM-DD')} onChange={(e) => { setDate(e.target.value) }}></input>
                        </IonItem>
                        <IonItem>
                            <IonLabel position='floating'>Bill No.</IonLabel>
                            <IonInput type='number' value={Config.gst.enabled ? gstBillNo : billNo} onIonInput={(e) => { setBillNo(e.target.value) }} id="billNo" ></IonInput>
                        </IonItem>
                    </IonCol>
                </IonRow>

                <IonRow>
                    <IonCol sizeMd='3'>
                        {
                            Config.gst.enabled ? (
                                <h6 id='total'>SubTotal : {subTotal.toFixed(2)}</h6>
                            ) : (
                                <h4 id='total'>Total : Rs. {total.toFixed(2)}</h4>
                            )
                        }
                    </IonCol>
                    <IonCol sizeMd='3' offsetMd='5' >{
                        Config.gst.enabled && (
                            <h5 id='total'>Total : {total.toFixed(2)}</h5>
                        )
                    }</IonCol>
                </IonRow>

                {ProductTable}
                <IonItemDivider />
                <IonRow>
                    <IonCol sizeMd='8'>
                        <AddItem addProduct={addProduct} />
                    </IonCol>
                    <IonCol sizeMd='3'>
                        <IonItem>
                            <IonLabel position='floating'>Amt Paid</IonLabel>
                            <IonInput type='number' placeholder='Amount Paid ' value={AmtPaid} id="amtPaid" onIonInput={(e) => { setAmtPaid(parseFloat(e.target.value)) }}></IonInput>
                        </IonItem>
                        <IonButton color='success' shape='round' type='submit' onClick={AddtoPurachase}>Add to Entry</IonButton>
                    </IonCol>
                </IonRow>

            </IonContent>
        </IonPage>
    )
}

export default PurchaseEntry
